import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import style from "./post.module.css";
const cardPost = ({ post }) => {
  // console.log(post.id + post.foto + post.judul + post.updated_at);
  // return <p>Hiiii</p>;
  return (
    <Link to={`/post/${post.id}`} className={style.link_post}>
      <div className={style.card}>
        <div
          className={style.post_image}
          style={{
            backgroundImage: `url(${process.env.REACT_APP_LINK}foto/${post.foto})`,
          }}
        ></div>
        <div className={style.card_description}>
          <div className={style.card_title}>{post.judul}</div>
          <div className={style.card_info}>
            <span>
              <Icon icon="healthicons:ui-user-profile-outline" />
              {post.user.name}
            </span>
            <span>
              <Icon icon="healthicons:i-schedule-school-date-time" />
              {new Date(post.updated_at).toLocaleDateString()}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default cardPost;
